import styled from "styled-components";
import { OverlayCssProps } from "./Overlay.types";
import { ThemePalette } from "../../../theme";

export const PropelOverlay = styled.div<OverlayCssProps>`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  backdrop-filter: blur(2px);
  height: 100vh;
  background-color: ${(props: OverlayCssProps) => props.theme!.colorGrayDark}${50};
  width: ${(props: OverlayCssProps) => (props.fullWidth ? "100%" : "100vw")};
`;

export const OverlayContent = styled.div`
  width: 80%;
  margin: 10rem auto;
  text-align: center;
`;

PropelOverlay.defaultProps = {
  theme: ThemePalette,
};
